import { Flex, Text } from "@chakra-ui/layout";
import { useOktaAuth } from "@okta/okta-react";
import "@okta/okta-signin-widget/dist/css/okta-sign-in.min.css";
import React from "react";
import OktaSignInWidget from "../components/OktaSignInWidget";
import logo from "../logo.svg";

function LoginView({ config }: any) {
  const { oktaAuth } = useOktaAuth();

  const onSuccess = (tokens: any) => {
    oktaAuth.handleLoginRedirect(tokens);
  };

  const onError = (err: any) => {
    console.error("Error: Cannot Login", err);
  };

  return (
    <Flex
      height="100vh"
      overflowY="auto"
      flexDir="column"
      alignItems="center"
      paddingX={4}
      paddingY={16}
    >
      <img height="auto" width="175px" src={logo} alt="Lima One Capital Logo" />

      <Text
        marginTop={10}
        fontSize="xx-large"
        fontWeight="black"
        color="gray.600"
        textAlign="center"
      >
        Sign in to your account
      </Text>

      <Text marginTop={2} fontSize="md" fontWeight="500" color="gray.500">
        Create and edit quotes with the{" "}
        <b style={{ color: "var(--chakra-colors-brand-300)" }}>
          Pricing Engine
        </b>
      </Text>

      <OktaSignInWidget
        config={config}
        onSuccess={onSuccess}
        onError={onError}
      />
      <Text
        marginTop={8}
        maxW="500px"
        textAlign="center"
        fontSize="sm"
        color="gray.500"
      >
        For access to the Pricing Engine, please reach out to your Lima One
        representative for assistance
      </Text>
    </Flex>
  );
}

export default LoginView;
